import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_USER, GET_USER_BY_ID } from "../constants";
import { setGetCategoryList, setGetClientsData, setGetSingleClientId } from "../reusable/reusableSlice";

export const getUser = (data, setLoading) => async (dispatch) => {
  setLoading(true)
  try {
    const response = await axiosInstance.post(`user/get_all`, data);
    if (response?.data?.status) {
      dispatch({ type: GET_USER, userlist: response?.data?.response });
      // return response;
    }
    else {
      dispatch({ type: GET_USER, userlist: [] });
    }
    setLoading(false)
  } catch (err) {
    console.error(err);
    setLoading(false)
    dispatch({ type: GET_USER, userlist: [] });
  }
};

export const addUser = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/create", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/user")
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


export const updateUser = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      // window.location.reload()
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteUser = (id, setLoading, params) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`user/delete/${id}`);
    if (response?.data?.status) {
      dispatch(getUser(params, setLoading));
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`user/get_byid/${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_USER_BY_ID, userbyid: response.data.response });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  }
};

export const toggleOnboard = (data, one) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("zatca/toggle_zatca_phase", data);
    if (response?.data?.status) {
      dispatch(getUserById(one))
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const userCategoriesList = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("user/kyc_category_list", data);
    if (response?.data) {
      dispatch(setGetCategoryList(response?.data?.response))
    } else {
      dispatch(setGetCategoryList([]))
    }
    return response
  } catch (err) {
    console.error(err);
    dispatch(setGetCategoryList([]))
  }
};


export const generateNewReferralCode = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("user/generate_referral", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      window.location.reload()
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const clientsDataList = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("client/get_all", data);
    if (response?.data) {
      dispatch(setGetClientsData(response?.data?.response))
    } else {
      dispatch(setGetClientsData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetClientsData([]))
  }
};

export const addClient = (data, setLoading, setModal, modal) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("client/create", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      setModal(!modal)
      return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


export const singleClientid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`client/get_byid/${id}`);
    if (response?.data) {
      dispatch(setGetSingleClientId(response?.data?.response))
      return response.data
    } else {
      dispatch(setGetSingleClientId([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetSingleClientId([]))
  }
};

export const updateSingleClient = (data, setLoading, setModal, modal) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("client/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      setModal(!modal)
      dispatch(getUserById(data.parent_id));
      dispatch(clientsDataList({ parent_id: data.parent_id }));
      // window.location.reload()
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
